import { treeData, treeData2 } from './config';
import { ConfigConsumerProps } from '../config-provider/configConsumerProps';
export default {
  name: 'FcElectronicDocument',
  props: {
    /**
     * @description 选择默认值
     */
    defaultValue: {
      type: String,
      default: '1',
    },
    /**
     * @description 普通上传对应上传值
     */
    uploadType: {
      type: String,
      default: '1',
    },
    /**
     * @description 上传分类
     */
    plainOptions: {
      type: Array,
      default: () => {
        return [
          { label: '默认上传', value: '1' },
          { label: '电子公文发文', value: '2' },
          { label: '电子公文收文', value: '3' },
        ];
      },
    },
    // 对应tree值
    treeDataMap: {
      type: Array,
      default: () => {
        return [[], treeData, treeData2];
      },
    },
  },
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  data() {
    return {
      value: '1',
    };
  },
  methods: {
    onChange(e) {
      this.value = e.target.value;
    },
  },
  render() {
    const { plainOptions, defaultValue, uploadType, value, treeDataMap } = this;
    const { locale } = this.configProvider;
    return (
      <div>
        {locale.ElectronicDocument.upload}
        <a-radio-group
          options={plainOptions}
          default-value={defaultValue}
          onChange={this.onChange}
        />
        {value === uploadType && <fc-upload></fc-upload>}
        {value !== uploadType && <fc-upload-tree treeData={treeDataMap[value]}></fc-upload-tree>}
      </div>
    );
  },
};
